/*
 * Página de produto curva (sections/plenty-product.liquid)
 * galeria · fotos ampliadas · escolha de tamanho · sacola (window.PlentyCart) · avise-me · barra flutuante
 * blocos escuros (trocas, detalhes, tabela de medidas) · avaliações · Sugeridos / Visto por último
 */
(function () {
  function money(c) {
    var v = (c / 100).toFixed(2).split('.');
    v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + v[0] + ',' + v[1];
  }

  function init(el) {
    if (el.__ppdp) return;
    el.__ppdp = true;
    /* a página já chegou inteira: o bloco Sugeridos pode aparecer (ver .ppdp:not(.is-ready) no CSS) */
    el.classList.add('is-ready');
    var data = {};
    try { data = JSON.parse(el.querySelector('[data-ppdp-json]').textContent); } catch (e) { return; }
    var pix = parseFloat(el.dataset.pix) || 0;
    var parcelas = parseInt(el.dataset.parcelas, 10) || 1;
    var form = el.querySelector('[data-ppdp-form]');
    var idInput = el.querySelector('[data-ppdp-id]');
    var addBtn = el.querySelector('[data-ppdp-add]');
    var msg = el.querySelector('[data-ppdp-msg]');
    var fieldsets = el.querySelectorAll('[data-ppdp-opt]');
    var notify = el.querySelector('[data-ppdp-notify]');
    var chosen = null;

    /* ---------- galeria ---------- */
    var track = el.querySelector('[data-ppdp-track]');
    var bars = el.querySelectorAll('.ppdp__bars i');
    var count = el.querySelector('[data-ppdp-count]');
    var slides = track ? track.children : [];
    function step() { return slides[0] ? slides[0].getBoundingClientRect().width + 6 : 1; }
    function idx() { return Math.round(track.scrollLeft / step()); }
    var thumbs = el.querySelectorAll('[data-ppdp-th]');
    var thBox = el.querySelector('[data-ppdp-thumbs]');
    function paint() {
      var i = Math.min(slides.length - 1, Math.max(0, idx()));
      bars.forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      /* miniaturas: marca as fotos à vista (1 no celular, 2 no desktop) e mantém a marcada visível na aba */
      var per = Math.max(1, Math.round(track.clientWidth / step()));
      thumbs.forEach(function (t, k) {
        var on = k >= i && k < i + per;
        t.classList.toggle('is-on', on);
        if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      var cur = thumbs[i];
      if (cur && thBox && thBox.scrollWidth > thBox.clientWidth) {
        var l = cur.offsetLeft - thBox.clientWidth / 2 + cur.offsetWidth / 2;
        thBox.scrollTo({ left: l, behavior: 'smooth' });
      }
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        track.scrollTo({ left: +t.dataset.ppdpTh * step(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
    });
    if (track && slides.length > 1) {
      var raf = 0;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; paint(); });
      }, { passive: true });
      paint();
      var prev = el.querySelector('[data-ppdp-prev]');
      var next = el.querySelector('[data-ppdp-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: step(), behavior: 'smooth' }); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: -step(), behavior: 'smooth' }); }
      });
    }

    /* ---------- variantes ---------- */
    function selected() {
      var out = [];
      fieldsets.forEach(function (fs) {
        var on = fs.querySelector('.ppdp__val.is-on');
        out[+fs.dataset.ppdpOpt] = on ? on.dataset.v : null;
      });
      return out;
    }
    function find(opts) {
      return data.variants.filter(function (v) {
        return v.o.every(function (x, i) { return opts[i] == null || opts[i] === x; });
      });
    }
    function setPrice(v) {
      var box = el.querySelector('[data-ppdp-price] .pc-price');
      if (!box || !v) return;
      var pixPrice = Math.round(v.p * (100 - pix) / 100);
      var sale = v.c && v.c > v.p;
      var b = box.querySelector('.pc-price__l1 b');
      if (b) { b.textContent = money(pixPrice); b.classList.toggle('pc-discount', !!sale); }
      var s = box.querySelector('.pc-price__l1 s');
      if (sale) {
        if (!s) { s = document.createElement('s'); box.querySelector('.pc-price__l1').appendChild(s); }
        s.textContent = money(v.c);
      } else if (s) s.remove();
      var sm = box.querySelector('small');
      if (sm && parcelas > 1) sm.textContent = 'ou ' + parcelas + 'x de ' + money(v.p / parcelas) + ' sem juros';
      var barP = el.querySelector('[data-ppdp-bar-price]');
      if (barP) barP.textContent = money(pixPrice);
    }
    function update() {
      var opts = selected();
      var full = opts.every(function (x) { return x != null; });
      var list = find(opts);
      chosen = full && list.length === 1 && list[0].a ? list[0] : null;
      if (chosen) {
        idInput.value = chosen.id;
        setPrice(chosen);
        var u = new URL(location.href);
        u.searchParams.set('variant', chosen.id);
        history.replaceState(history.state, '', u.toString());
      }
      barSync();
      if (msg) msg.hidden = true;
    }

    /* ---------- avise-me (igual ao protótipo) ----------
       add: "Adicionar à sacola" · wait: tamanho esgotado escolhido → botão de contorno "Avise-me quando chegar"
       form: o botão dá lugar à linha de e-mail · done: "Avisaremos quando o X chegar" */
    var BELL = '<svg class="ppdp__abell" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></svg>';
    var CHK = '<svg class="ppdp__achk" viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
    var soldAll = addBtn && addBtn.hasAttribute('data-ppdp-soldout');
    var mode = soldAll ? 'wait' : 'add', outSz = data.single && soldAll ? '' : null;
    function barSync() {
      var bb = el.querySelector('[data-ppdp-bar-btn]');
      if (!bb || bb.disabled) return;
      if (mode === 'wait' || mode === 'form') bb.textContent = outSz ? 'Avise-me · ' + outSz : 'Avise-me';
      else if (mode === 'done') bb.textContent = 'Avisaremos';
      else bb.textContent = chosen || data.single ? 'Adicionar à sacola' : 'Escolher tamanho';
    }
    function ring() {
      var b = addBtn.querySelector('.ppdp__abell');
      if (!b) return;
      b.classList.remove('is-ring');
      void b.getBoundingClientRect();
      b.classList.add('is-ring');
    }
    function setMode(m) {
      mode = m;
      if (!addBtn) return;
      addBtn.classList.remove('is-wait', 'is-done');
      addBtn.hidden = false;
      addBtn.disabled = false;
      if (notify && m !== 'form') notify.hidden = true;
      if (m === 'wait') {
        addBtn.classList.add('is-wait');
        addBtn.innerHTML = '<span class="ppdp__add-l">' + BELL + 'Avise-me quando chegar</span>';
        setTimeout(ring, 260);
      } else if (m === 'form') {
        addBtn.hidden = true;
        if (notify) {
          notify.hidden = false;
          var inp = notify.querySelector('input[type=email]');
          if (inp) inp.focus({ preventScroll: true });
        }
      } else if (m === 'done') {
        addBtn.classList.add('is-done');
        addBtn.innerHTML = '<span class="ppdp__add-l">' + CHK + (outSz ? 'Avisaremos quando o ' + outSz + ' chegar' : 'Avisaremos quando chegar') + '</span>';
      } else {
        addBtn.textContent = 'Adicionar à sacola';
      }
      barSync();
    }
    function showNotify(fs, btn) {
      if (!notify) return;
      var opts = selected();
      opts[+fs.dataset.ppdpOpt] = btn.dataset.v;
      var v = find(opts)[0];
      var tags = notify.querySelector('[data-ppdp-tags]');
      if (tags && v) tags.value = tags.value.split(',').filter(function (t) { return t.indexOf('avise-me-v') !== 0; }).concat('avise-me-v' + v.id).join(',');
      outSz = btn.dataset.v;
      setMode('wait');
      el.dispatchEvent(new CustomEvent('plenty:avise-me', { bubbles: true, detail: { variantId: v && v.id, value: btn.dataset.v } }));
    }
    fieldsets.forEach(function (fs) {
      fs.addEventListener('click', function (e) {
        var b = e.target.closest('.ppdp__val');
        if (!b) return;
        e.preventDefault();
        if (b.classList.contains('is-out')) {
          fs.querySelectorAll('.ppdp__val').forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
          chosen = null;
          b.classList.add('is-on');
          b.setAttribute('aria-pressed', 'true');
          fs.classList.remove('is-need');
          if (msg) msg.hidden = true;
          showNotify(fs, b);
          return;
        }
        if (mode !== 'add' && !soldAll) { outSz = null; setMode('add'); }
        fs.querySelectorAll('.ppdp__val').forEach(function (x) {
          var on = x === b;
          x.classList.toggle('is-on', on);
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        fs.classList.remove('is-need');
        update();
      });
    });

    function needSize() {
      fieldsets.forEach(function (fs) {
        if (!fs.querySelector('.ppdp__val.is-on')) {
          fs.classList.remove('is-need');
          void fs.offsetWidth;
          fs.classList.add('is-need');
        }
      });
      if (msg) { msg.textContent = soldAll ? 'Escolha o tamanho para ser avisado.' : 'Escolha o tamanho.'; msg.hidden = false; }
      var first = el.querySelector('[data-ppdp-opt]');
      if (first && first.getBoundingClientRect().top < 60) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function add() {
      if (mode === 'done') return;
      if (mode === 'wait' || mode === 'form') {
        if (outSz == null) { needSize(); return; }
        setMode('form');
        return;
      }
      var id = data.single ? data.variants[0].id : chosen && chosen.id;
      if (!id) { needSize(); return; }
      if (!window.PlentyCart) { form.submit(); return; }
      addBtn.disabled = true;
      addBtn.classList.add('is-busy');
      window.PlentyCart.add(id, 1)
        .then(function () {
          addBtn.textContent = 'Adicionado ✓';
          setTimeout(function () { addBtn.textContent = 'Adicionar à sacola'; }, 1600);
        })
        .catch(function (e) {
          if (msg) { msg.textContent = (e && (e.description || e.message)) || 'Não deu para adicionar. Tente de novo.'; msg.hidden = false; }
        })
        .finally(function () {
          addBtn.disabled = false;
          addBtn.classList.remove('is-busy');
        });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(); });

    /* seleção vinda da URL (?variant=) */
    var pre = el.dataset.selected;
    if (pre) update();

    /* ---------- avise-me: envio ----------
       Vai pelo formulário de cliente da Shopify (cria/atualiza o cliente com as tags avise-me). A Shopify protege esse
       formulário com captcha invisível, então o envio é o normal: a página volta com customer_posted=true e o botão
       aparece como "Avisaremos quando o X chegar". O tamanho fica guardado só para esse retorno. */
    var nf = notify && notify.querySelector('form');
    if (nf) nf.addEventListener('submit', function () {
      try { sessionStorage.setItem('plenty:avise', JSON.stringify({ h: data.handle, s: outSz || '' })); } catch (x) {}
      var go = nf.querySelector('.ppdp__nf-go');
      if (go) go.textContent = 'Enviando…';
    });
    if (notify && /customer_posted=true/.test(location.search)) {
      var back = null;
      try { back = JSON.parse(sessionStorage.getItem('plenty:avise') || 'null'); sessionStorage.removeItem('plenty:avise'); } catch (x) {}
      if (back && back.h === data.handle) {
        outSz = back.s;
        fieldsets.forEach(function (fs) {
          fs.querySelectorAll('.ppdp__val').forEach(function (x) {
            var on = x.dataset.v === back.s;
            x.classList.toggle('is-on', on);
            x.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        });
        setMode('done');
        setTimeout(function () { addBtn.scrollIntoView({ block: 'center' }); }, 60);
      }
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mode === 'form') { setMode('wait'); addBtn.focus(); }
    });

    /* ---------- barra flutuante ---------- */
    var bar = el.querySelector('[data-ppdp-bar]');
    var barBtn = el.querySelector('[data-ppdp-bar-btn]');
    if (bar && addBtn && 'IntersectionObserver' in window) {
      var past = false, foot = false;
      function paintBar() {
        var on = past && !foot;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (barBtn) barBtn.tabIndex = on ? 0 : -1;
      }
      new IntersectionObserver(function (es) {
        es.forEach(function (x) { past = !x.isIntersecting && x.boundingClientRect.top < 0; });
        paintBar();
      }).observe(addBtn);
      var footer = document.querySelector('footer, .shopify-section-group-footer-group');
      if (footer) new IntersectionObserver(function (es) {
        es.forEach(function (x) { foot = x.isIntersecting; });
        paintBar();
      }, { rootMargin: '0px 0px -45% 0px' }).observe(footer);
      if (barBtn) barBtn.addEventListener('click', function () {
        if (mode === 'done') { addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        if ((mode === 'wait' || mode === 'form') && outSz != null) {
          (addBtn.hidden ? notify : addBtn).scrollIntoView({ behavior: 'smooth', block: 'center' });
          setMode('form');
          return;
        }
        if (chosen || data.single) { add(); return; }
        var fs = el.querySelector('[data-ppdp-opt]');
        if (fs) {
          fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(needSize, 350);
        }
      });
    }
    update();

    /* ---------- "Veja quando chega": frete no lugar (CEP → prazo e valor) ----------
       Frenet pelo carrinho (window.PlentyFrete, em assets/plenty-sacola.js), com a variante escolhida.
       Mostra a opção mais barata: "Chega até d/mês · valor". Esc ou campo vazio ao sair volta ao normal. */
    var ship = el.querySelector('[data-ppdp-ship]');
    if (ship) {
      var MES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
      var TRK = ship.querySelector('svg').outerHTML;
      var CHEV = '<svg class="ppdp__chev" viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>';
      var freteSmall = ship.querySelector('small').innerHTML;
      var sst = {};
      var esc = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
      var drawShip = function (anim) {
        ship.classList.toggle('is-f', !!sst.open);
        ship.classList.toggle('is-ok', !!sst.ok);
        if (sst.ok) {
          ship.innerHTML = TRK + '<span class="ppdp__p2"><span class="ppdp__eta">Chega até <b>' + esc(sst.d) + '</b> · ' + esc(sst.v) + '</span><small>' + freteSmall + '</small></span><button type="button" class="ppdp__plink" data-a="alt">Alterar</button>';
        } else if (sst.open) {
          ship.innerHTML = TRK + '<input class="ppdp__ship-in" id="ppdp-cep" placeholder="00000-000" inputmode="numeric" autocomplete="postal-code" maxlength="9" aria-label="Seu CEP" value="' + esc(sst.v0 || '') + '"><button type="button" class="ppdp__plink" data-a="calc">' + (sst.busy ? 'Calculando' : 'Calcular') + '</button>' + (sst.err ? '<p class="ppdp__ship-err">' + esc(sst.err) + '</p>' : '');
        } else {
          ship.innerHTML = TRK + '<span class="ppdp__p2"><b>Veja quando chega</b><small>' + freteSmall + '</small></span>' + CHEV;
        }
        if (anim && !matchMedia('(prefers-reduced-motion: reduce)').matches && ship.animate) {
          [].slice.call(ship.children, 1).forEach(function (c, i) {
            c.animate([{ opacity: 0, transform: 'translateY(4px)' }, { opacity: 1, transform: 'none' }], { duration: 240, delay: i * 30, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'backwards' });
          });
        }
      };
      var focusCep = function () { var c = ship.querySelector('#ppdp-cep'); if (c) { c.focus(); c.setSelectionRange(c.value.length, c.value.length); } };
      var brl = function (c) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ','); };
      var quote = function (cep) {
        var v = chosen || data.variants.filter(function (x) { return x.a; })[0] || data.variants[0];
        var q = parseInt((el.querySelector('input[name="quantity"]') || {}).value, 10) || 1;
        sst = { open: true, v0: cep, busy: true };
        drawShip(false);
        if (!window.PlentyFrete) { sst = { open: true, v0: cep, err: 'Não deu para calcular agora. Tente de novo.' }; drawShip(true); return; }
        /* Frenet pelo carrinho: sacola atual + esta peça (a peça entra só durante o cálculo) */
        window.PlentyFrete.cotar(cep, v.id, q)
          .then(function (m) {
            if (!m) { sst = { open: true, v0: cep, err: 'Não encontramos entrega para este CEP.' }; drawShip(true); focusCep(); return; }
            sst = { ok: 1, v: m.v === 0 ? 'Grátis' : brl(m.v), d: m.d || m.nome, cep: cep };
            drawShip(true);
          })
          .catch(function (e) { sst = { open: true, v0: cep, err: (e && e.msg) || 'Não deu para calcular agora. Tente de novo.' }; drawShip(true); focusCep(); });
      };
      ship.addEventListener('click', function (e) {
        var b = e.target.closest('[data-a]');
        if (!b && !sst.open && !sst.ok) { sst = { open: true }; drawShip(true); focusCep(); return; }
        if (!b) return;
        var a = b.dataset.a;
        if (a === 'alt') { sst = { open: true, v0: sst.cep }; drawShip(true); focusCep(); return; }
        if (a === 'calc') {
          var inp = ship.querySelector('#ppdp-cep'), d = (inp.value || '').replace(/\D/g, '');
          if (d.length !== 8) { sst = { open: true, v0: inp.value, err: 'Digite os 8 números do CEP.' }; drawShip(false); focusCep(); return; }
          quote(d.slice(0, 5) + '-' + d.slice(5));
        }
      });
      ship.addEventListener('keydown', function (e) {
        if (e.target === ship && (e.key === 'Enter' || e.key === ' ') && !sst.open && !sst.ok) { e.preventDefault(); ship.click(); return; }
        if (e.target.id !== 'ppdp-cep') return;
        if (e.key === 'Enter') { e.preventDefault(); ship.querySelector('[data-a="calc"]').click(); }
        if (e.key === 'Escape') { sst = {}; drawShip(true); ship.focus(); }
      });
      ship.addEventListener('input', function (e) {
        if (e.target.id !== 'ppdp-cep') return;
        var d = e.target.value.replace(/\D/g, '').slice(0, 8);
        e.target.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
        var er = ship.querySelector('.ppdp__ship-err');
        if (er) { er.remove(); sst.err = null; }
      });
      ship.addEventListener('focusout', function (e) {
        if (e.target.id !== 'ppdp-cep' || e.target.value || ship.contains(e.relatedTarget)) return;
        setTimeout(function () { var c = ship.querySelector('#ppdp-cep'); if (sst.open && !sst.busy && c && !c.value) { sst = {}; drawShip(true); } }, 120);
      });
    }

    /* ---------- "Trocas" e "Detalhes": bloco escuro ----------
       Celular: abre logo abaixo da linha (a altura cresce e o conteúdo sobe 4px). Tocar de novo fecha.
       Desktop: folha que sai do bloco da linha e cobre o painel de compra; Fechar, Esc ou clique fora fecham. */
    var mqDesk = window.matchMedia('(min-width: 960px)');
    var sheet = el.querySelector('[data-ppdp-sheet]');
    var sheetIn = sheet && sheet.querySelector('.ppdp__sheet-in');
    var sheetB = sheet && sheet.querySelector('[data-ppdp-sheet-b]');
    var openP = null, sheetTrig = null, raf = 0;
    var tplOf = function (k) { return el.querySelector('[data-ppdp-tpl="' + k + '"]'); };
    /* a página não pula quando o bloco abre ou fecha (o navegador tentaria manter o botão de baixo no lugar) */
    var still = function () {
      var r = document.documentElement;
      r.style.overflowAnchor = 'none';
      clearTimeout(still._t);
      still._t = setTimeout(function () { r.style.overflowAnchor = ''; }, 600);
    };
    var shut = function (p) {
      if (!p) return;
      still();
      if (p._trig) { p._trig.classList.remove('is-open'); p._trig.setAttribute('aria-expanded', 'false'); }
      p.classList.remove('is-on');
      setTimeout(function () { if (p.parentNode) p.parentNode.removeChild(p); }, 460);
    };
    var blockOf = function (t) { return t.closest('.ppdp__blk') || t; };
    var geo = function () {
      var col = el.querySelector('[data-ppdp-buy]').getBoundingClientRect();
      var b = blockOf(sheetTrig).getBoundingClientRect();
      var t = Math.max(16, col.top + 6);
      var hb = document.querySelector('.hc__tab');
      if (hb) { var pr = hb.getBoundingClientRect(); if (pr.right > b.left + 8 && pr.left < b.right - 8) t = Math.max(t, Math.round(pr.bottom + 6)); }
      var last = sheetB.lastElementChild;
      var nat = last ? Math.ceil(last.getBoundingClientRect().bottom - sheetB.getBoundingClientRect().top + sheetB.scrollTop + 22 + 48) : 9999;
      var H = Math.min(innerHeight - 16 - t, nat);
      t = Math.round(Math.min(Math.max(b.top, t), innerHeight - 16 - H));
      sheet.style.setProperty('--hl', b.left.toFixed(1) + 'px');
      sheet.style.setProperty('--hw', b.width.toFixed(1) + 'px');
      sheet.style.setProperty('--ht', t + 'px');
      sheet.style.setProperty('--hh', H + 'px');
      return { L: b.left, W: b.width, t: t, H: H };
    };
    var origin = function (g) {
      var b = blockOf(sheetTrig).getBoundingClientRect();
      var tp = Math.max(0, b.top - g.t), bt = Math.max(0, g.t + g.H - b.bottom), lf = Math.max(0, b.left - g.L), rt = Math.max(0, g.L + g.W - b.right);
      if (tp + bt > g.H - 8) { tp = 0; bt = g.H - 2; }
      sheet.style.setProperty('--o0', 'inset(' + tp + 'px ' + rt + 'px ' + bt + 'px ' + lf + 'px round 10px)');
    };
    var follow = function () {
      raf = 0;
      if (!sheet || sheet.hidden) return;
      var g = geo();
      if (sheet.classList.contains('is-out')) origin(g);
      raf = requestAnimationFrame(follow);
    };
    var sheetOpen = function (trig, k) {
      var tpl = tplOf(k);
      if (!tpl || !sheet) return;
      sheetTrig = trig;
      sheet.querySelector('#ppdp-sheet-t').textContent = tpl.dataset.title;
      sheetB.innerHTML = '<div class="ppdp__dk">' + tpl.innerHTML + '</div>';
      sheetB.scrollTop = 0;
      sheet.classList.remove('is-out');
      sheet.classList.add('is-in');
      sheet.hidden = false;
      var g = geo();
      origin(g);
      sheetIn.offsetWidth;
      requestAnimationFrame(function () { sheet.classList.remove('is-in'); });
      if (!raf) raf = requestAnimationFrame(follow);
      sheet.querySelector('[data-ppdp-sheet-x]').focus({ preventScroll: true });
    };
    var sheetClose = function () {
      if (!sheet || sheet.hidden || sheet.classList.contains('is-out')) return;
      origin(geo());
      sheet.classList.add('is-out');
      setTimeout(function () {
        sheet.hidden = true;
        sheet.classList.remove('is-out');
        if (sheetTrig) sheetTrig.focus({ preventScroll: true });
      }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 190);
    };
    el.querySelectorAll('[data-ppdp-open]').forEach(function (trig) {
      trig.addEventListener('click', function () {
        var k = trig.dataset.ppdpOpen;
        if (mqDesk.matches) { sheetOpen(trig, k); return; }
        if (openP && openP._trig === trig) { var p0 = openP; openP = null; shut(p0); return; }
        var prev = openP;
        openP = null;
        shut(prev);
        var tpl = tplOf(k);
        if (!tpl) return;
        var p = document.createElement('div');
        p.className = 'ppdp__minl';
        p.innerHTML = '<div class="ppdp__minl-in"><div class="ppdp__minl-box"><div class="ppdp__minl-b ppdp__dk">' + tpl.innerHTML + '</div></div></div>';
        p._trig = trig;
        trig.classList.add('is-open');
        trig.setAttribute('aria-expanded', 'true');
        still();
        var at = trig.dataset.ppdpAfter ? trig.closest(trig.dataset.ppdpAfter) || trig : trig;
        at.insertAdjacentElement('afterend', p);
        p.offsetHeight;
        p.classList.add('is-on');
        openP = p;
      });
    });
    /* abrir e fechar os itens de "Detalhes" (só no celular; na folha tudo fica aberto) */
    el.addEventListener('click', function (e) {
      var h = e.target.closest('.ppdp__minl .ppdp__acc-h');
      if (!h) return;
      var a = h.parentNode, on = !a.classList.contains('is-on');
      a.classList.toggle('is-on', on);
      h.setAttribute('aria-expanded', on);
    });
    if (sheet) {
      sheet.addEventListener('click', function (e) { if (e.target === sheet || e.target.closest('[data-ppdp-sheet-x]')) sheetClose(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') sheetClose(); });
    }
    mqDesk.addEventListener('change', function () {
      if (mqDesk.matches && openP) { var p = openP; openP = null; shut(p); }
      if (!mqDesk.matches && sheet && !sheet.hidden) { sheet.hidden = true; }
    });

    /* ---------- fotos ampliadas: tocar na foto abre a tela cheia; arrastar passa; Esc ou Fechar fecham ---------- */
    var zoom = el.querySelector('[data-ppdp-zoom]');
    if (zoom && track) {
      var zt = zoom.querySelector('[data-ppdp-zoom-t]');
      var zn = zoom.querySelector('[data-ppdp-zoom-n]');
      var zfrom = null, zraf = 0;
      var zpaint = function () {
        zraf = 0;
        if (!zn) return;
        var i = Math.round(zt.scrollLeft / Math.max(1, zt.clientWidth));
        zn.textContent = (i + 1) + ' / ' + zt.children.length;
      };
      zt.addEventListener('scroll', function () { if (!zraf) zraf = requestAnimationFrame(zpaint); }, { passive: true });
      var zopen = function (i) {
        zfrom = document.activeElement;
        zoom.hidden = false;
        zoom.classList.remove('is-out');
        document.documentElement.classList.add('ppdp-lock');
        zt.scrollLeft = i * zt.clientWidth;
        zpaint();
        zoom.querySelector('[data-ppdp-zoom-x]').focus({ preventScroll: true });
      };
      var zclose = function () {
        if (zoom.hidden || zoom.classList.contains('is-out')) return;
        zoom.classList.add('is-out');
        setTimeout(function () {
          zoom.hidden = true;
          zoom.classList.remove('is-out');
          document.documentElement.classList.remove('ppdp-lock');
          if (zfrom && zfrom.focus) zfrom.focus({ preventScroll: true });
        }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 180);
      };
      track.addEventListener('click', function (e) {
        var f = e.target.closest('.ppdp__ph[data-i]');
        if (f) zopen(+f.dataset.i);
      });
      zoom.querySelector('[data-ppdp-zoom-x]').addEventListener('click', zclose);
      zoom.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.stopPropagation(); zclose(); }
        if (e.key === 'ArrowRight') zt.scrollBy({ left: zt.clientWidth, behavior: 'smooth' });
        if (e.key === 'ArrowLeft') zt.scrollBy({ left: -zt.clientWidth, behavior: 'smooth' });
        if (e.key === 'Tab') { e.preventDefault(); zoom.querySelector('[data-ppdp-zoom-x]').focus(); }
      });
    }

    /* ---------- modelo na foto: o botão abre o balão com as medidas ---------- */
    var mbtn = el.querySelector('[data-ppdp-mbtn]');
    var mpop = el.querySelector('[data-ppdp-mpop]');
    if (mbtn && mpop) {
      var mset = function (on) { mpop.hidden = !on; mbtn.setAttribute('aria-expanded', on ? 'true' : 'false'); if (on) mpop.classList.add('pc-in'); };
      mbtn.addEventListener('click', function (e) { e.stopPropagation(); mset(mpop.hidden); });
      document.addEventListener('click', function (e) { if (!mpop.hidden && !e.target.closest('[data-ppdp-mw]')) mset(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !mpop.hidden) mset(false); });
    }

    /* ---------- tabela: marca a coluna do tamanho que o modelo veste ---------- */
    var markTables = function (root) {
      root.querySelectorAll('.ppdp__table[data-mdl]').forEach(function (box) {
        var want = (box.dataset.mdl || '').trim().toUpperCase();
        var t = box.querySelector('table');
        if (!want || !t || t.__mdl) return;
        var head = t.rows[0];
        if (!head) return;
        var col = -1;
        [].forEach.call(head.cells, function (c, i) { if (c.textContent.trim().toUpperCase() === want) col = i; });
        if (col < 1) return;
        t.__mdl = true;
        [].forEach.call(t.rows, function (r) {
          var x = 0;
          [].some.call(r.cells, function (c) {
            var span = c.colSpan || 1;
            if (x === col && span === 1) c.classList.add('is-mdl');
            x += span;
            return x > col;
          });
        });
        var sm = document.createElement('small');
        sm.className = 'ppdp__mdl-tag';
        sm.textContent = 'modelo';
        head.cells[col].appendChild(sm);
      });
    };
    el.querySelectorAll('template[data-ppdp-tpl]').forEach(function (t) { markTables(t.content); });

    /* ---------- vídeos: player em tela cheia, um atrás do outro (como stories) ---------- */
    var story = el.querySelector('[data-ppdp-story]');
    var vids = [];
    try { vids = JSON.parse((el.querySelector('[data-ppdp-videos]') || {}).textContent || '[]'); } catch (e) { vids = []; }
    if (story && vids.length) {
      var sv = story.querySelector('[data-ppdp-st-v]');
      var sbars = story.querySelectorAll('.ppdp__st-bars b');
      var si = 0, sfrom = null;
      var sbar = function () {
        sbars.forEach(function (b, k) {
          var p = k < si ? 1 : k > si ? 0 : (sv.duration ? sv.currentTime / sv.duration : 0);
          b.style.transform = 'scaleX(' + p + ')';
        });
      };
      var sgo = function (i) {
        if (i < 0) i = 0;
        if (i >= vids.length) { sclose(); return; }
        si = i;
        sv.src = vids[i].src;
        if (vids[i].poster) sv.poster = vids[i].poster;
        sbar();
        var pl = sv.play();
        if (pl && pl.catch) pl.catch(function () { sv.muted = true; sv.play().catch(function () {}); });
      };
      var sclose = function () {
        if (story.hidden) return;
        sv.pause();
        story.classList.add('is-out');
        setTimeout(function () {
          story.hidden = true;
          story.classList.remove('is-out');
          sv.removeAttribute('src');
          sv.load();
          document.documentElement.classList.remove('ppdp-lock');
          if (sfrom && sfrom.focus) sfrom.focus({ preventScroll: true });
        }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 180);
      };
      sv.addEventListener('timeupdate', sbar);
      sv.addEventListener('ended', function () { sgo(si + 1); });
      el.querySelectorAll('[data-ppdp-pv]').forEach(function (b) {
        b.addEventListener('click', function () {
          sfrom = b;
          story.hidden = false;
          document.documentElement.classList.add('ppdp-lock');
          story.querySelector('[data-ppdp-st-x]').focus({ preventScroll: true });
          sgo(+b.dataset.ppdpPv);
        });
      });
      story.querySelector('[data-ppdp-st-prev]').addEventListener('click', function () { sgo(si - 1); });
      story.querySelector('[data-ppdp-st-next]').addEventListener('click', function () { sgo(si + 1); });
      story.querySelector('[data-ppdp-st-x]').addEventListener('click', sclose);
      story.addEventListener('click', function (e) { if (e.target === story) sclose(); });
      story.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.stopPropagation(); sclose(); }
        if (e.key === 'ArrowRight') sgo(si + 1);
        if (e.key === 'ArrowLeft') sgo(si - 1);
      });
    }

    /* ---------- avaliações: "Ver todas" mostra as que já vieram com a página ---------- */
    var rvBtn = el.querySelector('[data-ppdp-rv-btn]');
    if (rvBtn) rvBtn.addEventListener('click', function () {
      el.querySelectorAll('[data-ppdp-rv-more]').forEach(function (li) { li.hidden = false; li.classList.add('pc-in'); });
      var c = el.querySelector('[data-ppdp-rv-count]');
      if (c) c.textContent = 'Mostrando ' + rvBtn.dataset.n + ' de ' + rvBtn.dataset.total;
      rvBtn.remove();
    });

    /* ---------- Sugeridos / Visto por último (abas só no celular) ----------
       As peças abertas ficam guardadas no navegador (até 12). Os cards vêm de /products/<handle>?section_id=plenty-pcard. */
    var KEY = 'plenty:vistos';
    var seenList = [];
    try { seenList = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { seenList = []; }
    if (!Array.isArray(seenList)) seenList = [];
    var others = seenList.filter(function (h) { return h !== data.handle; }).slice(0, 8);
    try { localStorage.setItem(KEY, JSON.stringify([data.handle].concat(seenList.filter(function (h) { return h !== data.handle; })).slice(0, 12))); } catch (e) {}
    var rel = el.querySelector('[data-ppdp-rel]');
    if (rel) {
      var tabs = rel.querySelectorAll('[data-ppdp-tab]');
      var ind = rel.querySelector('.ppdp__tabs-ind');
      var seenBox = rel.querySelector('[data-ppdp-seen]');
      var loaded = false;
      var placeInd = function () {
        var on = rel.querySelector('[data-ppdp-tab][aria-selected="true"]');
        if (!on || !ind) return;
        ind.style.width = on.offsetWidth + 'px';
        ind.style.transform = 'translateX(' + on.offsetLeft + 'px)';
      };
      var loadSeen = function () {
        if (loaded) return;
        loaded = true;
        if (!others.length) { seenBox.innerHTML = '<p class="ppdp__rel-empty">As peças que você abrir aparecem aqui.</p>'; return; }
        seenBox.innerHTML = '<p class="ppdp__rel-empty">Carregando…</p>';
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        Promise.all(others.map(function (h) {
          return fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=plenty-pcard')
            .then(function (r) { return r.ok ? r.text() : ''; })
            .catch(function () { return ''; });
        })).then(function (list) {
          var html = list.map(function (t) {
            var d = document.createElement('div');
            d.innerHTML = t;
            var c = d.querySelector('[data-pcc]');
            return c ? c.outerHTML : '';
          }).join('');
          seenBox.innerHTML = html || '<p class="ppdp__rel-empty">As peças que você abrir aparecem aqui.</p>';
        });
      };
      var pick = function (t) {
        tabs.forEach(function (b) {
          var on = b === t;
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(b.getAttribute('aria-controls'));
          if (panel) { panel.hidden = !on; if (on) panel.classList.add('pc-in'); }
        });
        if (t.dataset.ppdpTab === 'vis') loadSeen();
        placeInd();
      };
      tabs.forEach(function (b) {
        b.addEventListener('click', function () { pick(b); });
        b.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var o = b === tabs[0] ? tabs[1] : tabs[0];
          o.focus();
          pick(o);
        });
      });
      placeInd();
      addEventListener('resize', placeInd);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeInd);
      /* no desktop as abas somem: volta para Sugeridos */
      mqDesk.addEventListener('change', function () { if (mqDesk.matches) pick(tabs[0]); });
    }
  }

  function boot() { document.querySelectorAll('[data-ppdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
